import {fetchJSONByPost} from './index.js'

export const sendToFeishu = (body) => fetchJSONByPost('https://open.feishu.cn/open-apis/bot/v2/hook/9914ef24-213f-4c92-9405-2afbe087f29b', body)